module.exports = __webpack_public_path__ + "assets/images/0d13ed0abca76a095a9dada1e7bdace0.png";